export const mediaResponseEntity: StrapiDataItem<MediaResponseEntity> = {
  id: 1,
  attributes: {
    name: 'test image',
    alternativeText: 'test alt text',
    caption: 'test caption',
    width: 1000,
    height: 500,
    formats: {
      small: {
        ext: 'jpg',
        url: '/media/small_test.jpg',
        hash: 'testhash',
        mime: 'image/jpeg',
        name: 'small_test',
        path: null,
        size: 100,
        width: 500,
        height: 250,
        provider_metadata: {
          public_id: 'public-id',
          resource_type: 'type',
        },
      },
      medium: {
        ext: 'jpg',
        url: '/media/medium_test.jpg',
        hash: 'testhash',
        mime: 'image/jpeg',
        name: 'medium_test',
        path: null,
        size: 200,
        width: 750,
        height: 375,
        provider_metadata: {
          public_id: 'public-id',
          resource_type: 'type',
        },
      },
      large: {
        ext: 'jpg',
        url: '/media/large_test.jpg',
        hash: 'testhash',
        mime: 'image/jpeg',
        name: 'large_test',
        path: null,
        size: 400,
        width: 1000,
        height: 675,
        provider_metadata: {
          public_id: 'public-id',
          resource_type: 'type',
        },
      },
      thumbnail: {
        ext: 'jpg',
        url: '/media/thumbnail_test.jpg',
        hash: 'testhash',
        mime: 'image/jpeg',
        name: 'thumbnail_test',
        path: null,
        size: 10,
        width: 15,
        height: 25,
        provider_metadata: {
          public_id: 'public-id',
          resource_type: 'type',
        },
      },
    },
    hash: 'testhash',
    ext: 'jpg',
    mime: 'image/jpeg',
    size: 300,
    url: '/media/test.jpg',
    previewUrl: null,
    provider: 'provider',
    provider_metadata: {
      public_id: 'public-id',
      resource_type: 'type',
    },
    createdAt: '2022-04-01T12:00:00.000Z',
    updatedAt: '2022-04-01T12:00:00.000Z',
  },
}
